<div class="flex h-screen bg-gray-100">
  <aside class="w-72 overflow-y-auto bg-white text-black shadow-2xl">
    <app-sidenav></app-sidenav>
  </aside>
  <div class="flex flex-col flex-1 w-full">
    <div class="h-full overflow-y-auto">
      <app-title [title]="title"></app-title>
      <div class="container px-6 mx-auto grid pt-8">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
